import React from 'react';
import { Text } from '~/commonComponents/Text/Text';
import { Colors } from '~/themes/colors';

type TBadgeVariant = 'error' | 'warning';

interface IVariantStyle {
  backgroundColor: string;
  textColor: string;
}

type TVariantStyles = Record<TBadgeVariant, IVariantStyle>;

interface IProps {
  variant: TBadgeVariant;
  label: string;
  className?: string;
  testId?: string;
  dataCy?: string;
  style?: React.CSSProperties;
}

const variantStyles: TVariantStyles = {
  error: {
    backgroundColor: Colors.error_50,
    textColor: Colors.error_500,
  },
  warning: {
    backgroundColor: Colors.warning_50,
    textColor: Colors.warning_700,
  },
};

/**
 * Badge Component
 *
 * Renders a badge with a specified variant and label.
 *
 * @example
 * <Badge variant="error" label="Error" />
 * <Badge variant="warning" label="Warning" />
 */
export const Badge: React.FC<IProps> = ({ variant, label, testId, dataCy, style }) => {
  const styles = variantStyles[variant];

  return (
    <Text
      backgroundColor={styles.backgroundColor}
      color={styles.textColor}
      borderRadius={3}
      paddingVertical={2}
      paddingHorizontal={7}
      fontSize={14}
      bold
      style={{ textTransform: 'uppercase', ...style }}
      width="fit-content"
      data-testid={testId}
      data-cy={dataCy}
    >
      {label}
    </Text>
  );
};
